module.exports = __webpack_public_path__ + "img/向上滑动@2x.3ae2e862.png";